export default __webpack_public_path__ + "static/media/approved.2b19de42.png";